export enum TopUpTicketsStatus {
  /// Can be loaded when topped up
  UnloadedActive = 0,

  /// Can be topped up and balance restored to account
  LoadedHasMoney = 1,

  /// Cannot be topped up but is loaded and doesn't have any value assigned to it
  LoadedNoMoney = 2,

  /// Ticket has to be moved to UnloadedActive before it can be topped up
  /// Ticket Inactive
  UnloadedBlocked = 3
}
